import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { closePopup } from '../../actions/uiActions'
import { changeQPs } from '../../actions/queryActions'
import { dynamicSort } from '../utilities/helperFunctions'
import { refreshPresentation } from '../../actions/presentationActions'
import { withRouter } from '../../actions/withRouterHook'
import { doesThisUserHaveThisAuthorization } from '../../components/utilities/helperFunctions'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';

function EditQuickPickPopupFunctional(props) {
    let navigate = useNavigate()
    let [qpSelections, setQpSelections] = useState({})
    let [hideComps, setHideComps] = useState({})
    let [dimensions, setDimensions] = useState([
        {
            "id": 0,
            "dimensionName": "Test Dimension",
            "dataSourceWitMostMembers": "",
            "dominantDataSources": [""],
            "targetAlias": "",
            "members": [],
            "segments": [],
            "compDataSource": [],
            "linkMap": {},
            "linkMaps": [],
            "dimensionAliases" : []
        }
    ])
    let [hasCustomQuickPicks, setHasCustomQuickPicks] = useState(false)
    let [dimensionAliases, setDimensionAliases] = useState([])
    let [updateCounter, setUpdateCounter] = useState(0)
    let [globalSetMembers, setGlobalSetMembers] = useState([])
    let [globalSelections, setGlobalSelections] = useState([])
    let [uniqueGlobalSets, setUniqueGlobalSets] = useState([])
    let [userSelectedGlobalSet, setUserSelectedGlobalSet] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (props.currentQPs.length > 0 && props.qpDataSource.dimensions && props.qpDataSource.dimensions.length > 0 && Object.keys(qpSelections).length === 0) {
            //Sorting here determines the order of the dropdowns
            props.currentQPs.sort(dynamicSort("tagName"))

            let hasCustomQuickPicks = doTheseQuickPicksHaveCustomQuickPicks(props.currentQPs)
            let dimensions = formatDimensionStateObject(props.qpDataSource, props.currentQPs, hasCustomQuickPicks)
            let qpSelectionsObj = formatQpSelectionsObj(props.qpDataSource, props.currentQPs, hasCustomQuickPicks)
            let dimensionAliases = formatQpSelectionsDimensionAliases(props.currentQPs)
            let globalsObj = formatGlobalPicksSourceObject(props.qpDataSource)
            let globalsSelectionsObject = formatGlobalPicksSelections(props.presentationView.globals, props.qpDataSource)
            let allUniqueGlobalSets = formatAllUniqueGlobalSets(props.presentationView.globals)

            setHasCustomQuickPicks(hasCustomQuickPicks)
            setDimensions(dimensions)
            setQpSelections(qpSelectionsObj)
            setDimensionAliases(dimensionAliases)
            setGlobalSetMembers(globalsObj)
            setGlobalSelections(globalsSelectionsObject)
            setUniqueGlobalSets(allUniqueGlobalSets)

            if (allUniqueGlobalSets.length > 1) {
                setUserSelectedGlobalSet(allUniqueGlobalSets[1])
            }
        } else if (props.qpDataSource && globalSetMembers.length === 0) {
            let globalsObj = formatGlobalPicksSourceObject(props.qpDataSource)
            let globalsSelectionsObject = formatGlobalPicksSelections(props.presentationView.globals, props.qpDataSource)
            let allUniqueGlobalSets = formatAllUniqueGlobalSets(props.presentationView.globals)
            setGlobalSetMembers(globalsObj)
            setGlobalSelections(globalsSelectionsObject)
            setUniqueGlobalSets(allUniqueGlobalSets)
            
            if (allUniqueGlobalSets.length > 1) {
                setUserSelectedGlobalSet(allUniqueGlobalSets[1])
            }
        }
    }, [])

    return (
        <Dialog open={true} onClose={handleClick}>
            <CloseIcon onClick={handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {'XP3 Quick Picks'}
            </DialogTitle>
            <DialogContent id="alert-dialog-description">
                <div className="wideCenterBox" style={{ height: "auto", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} id={`center-box-ticks-${updateCounter}`}>
                    {dimensions.map((data, index) => {
                        let id = data.id;
                        let targetAlias = data.targetAlias;
                        let currentQP = qpSelections[id];

                        if (currentQP) {
                            let members = data.members.sort(dynamicSort("alias"));
                            let segments = data.segments;
                            let dataSourceWitMostMembers = data.dataSourceWitMostMembers;
                            let valueAlias = currentQP[targetAlias];
                            let qpKeys = Object.keys(currentQP);
                            return (
                                <div className="passwordResetbox" key={`password-reset-box-${index}`}>
                                    <h5>{data.dimensionName}: {data.targetAlias}</h5>
                                    <div className="myInputOut" identifier="h">
                                        {renderPrimaryDropDown(hasCustomQuickPicks, members, segments, id, targetAlias, qpSelections, valueAlias, data.linkMap, data.linkMaps, data.compDataSource, dataSourceWitMostMembers)}
                                    </div>
                                    {renderAccordianSubDropDowns(qpKeys, targetAlias, data.dimensionName, members, data.compDataSource, id, qpSelections, hasCustomQuickPicks, data.linkMap, data.dominantDataSources)}
                                </div>
                            );
                        } else {
                            return null; // Appeasing the node warnings
                        }
                    })}
                </div>
                {renderBasicGlobalsArea()}
                {renderGlobalSetsDropdown()}
                {renderEditGlobalSetsArea()}
                <button className="btn" type="submit" onClick={handleRefreshPresentation}>Update</button>
            </DialogContent>
        </Dialog >
    );

    //#region Events
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }
    function handleChange(newValue, id1, id2) {
        let arr = qpSelections
        arr[id1][id2] = newValue
        let keys = Object.keys(arr[id1])

        if ((id2 === "Target Selection" || id2.includes("Target Selection")) && !id2.includes("Comp")) {
            for (let i = 0; i < keys.length; i++) {
                if (keys[i].includes("Comp")) {
                    arr[id1][keys[i]] = newValue
                }
            }
        }

        let counter = updateCounter + 1;
        setQpSelections(arr)
        setUpdateCounter(counter)
    }
    function handleChangeForAnchor(newValue, id1, id2, nonAnchorMembers) {
        let counter = updateCounter + 1;
        let arr = qpSelections
        arr[id1][id2] = newValue
        let keys = Object.keys(arr[id1])
        
        keys.forEach(key => {
            if (key !== id2 && key.startsWith('^')) {
                let lookup = key.substring(1)
                
                // We have a situation where the link maps themselves do not apply to all data sources
                if (nonAnchorMembers[lookup]) {
                    let members = nonAnchorMembers[lookup].members.find(na => na.alias.toLowerCase() === newValue.toLowerCase())
                    
                    // For now lets take the non anchors and empty them instead of having a residual previous selection
                    arr[id1][key] = (members && members.children) ? members.children[0].alias : ""
                }
            }
        })

        setQpSelections(arr)
        setUpdateCounter(counter)
    }
    function handleRefreshPresentation(event) {
        event.preventDefault()

        let documentTypeId = -1
        if (typeof (props.presentationView.slides) !== "undefined") {
            documentTypeId = 0
        } else if (typeof (props.presentationView.sheets) !== "undefined") {
            documentTypeId = 1
        }

        let copiedGlobalSelections = globalSelections

        if (!doesThisUserHaveThisAuthorization(props.currentUser, 'AdvancedGlobalEdit')) {
            copiedGlobalSelections = []
        }

        props.refreshPresentation(
            props.presentationView.id,
            documentTypeId,
            props.currentDatabase.id,
            userSelectedGlobalSet,
            copiedGlobalSelections,
            Object.keys(qpSelections),
            Object.values(qpSelections),
            dimensionAliases)
        navigate('/presentations')
    }
    //#endregion

    //#region Private Data Handling - State Object [qpSelections]
    function formatQpSelectionsObj(qpDataSource, currentQPs, hasCustomQuickPicks) {
        let rtnVal = {}

        qpDataSource.dimensions.forEach((dimension) => {
            let currentQp = currentQPs.find(qp => qp.quickPicksTag.dimensionAlias === dimension.alias)
            if (currentQp) {
                let qpId = currentQp.id
                let isCustomQuickPickDropDown = hasCustomQuickPicks && currentQp.quickPicksTag.linkMaps !== null
                let formatQp = {}
                if (isCustomQuickPickDropDown) {
                    formatQp = formatQpObjForCustomQuickPicks(qpDataSource, currentQp)
                } else {
                    formatQp = formatQpObjForStandardQuickPicks(qpDataSource, currentQp)
                }

                if (formatQp[qpId]) {
                    rtnVal[qpId] = formatQp[qpId]
                }
            }
        })

        return rtnVal
    }
    function formatQpObjForStandardQuickPicks(qpDataSource, currentQp) {
        let rtnVal = {}

        // Go through each dimension and build up the Quick Pick Object
        qpDataSource.dimensions.forEach((dimension) => {
            if (currentQp.quickPicksTag.dimensionAlias === dimension.alias) {
                let members = dimension.members
                if (doesThisDimensionHaveRelevantMembers(dimension) && currentQp) {
                    let qpId = currentQp.id
                    let targetAlias = currentQp.quickPicksTag.targetAlias
                    let targetSelection = currentQp.quickPicksTag.targetSelection

                    rtnVal[qpId] = {}
                    rtnVal[qpId][targetAlias] = targetSelection

                    // Next we need to fill out the comps
                    let compDataSource = findDataSourceSelectionWithTheMostMembers(currentQp)
                    compDataSource.forEach(dataSource => {
                        if (dataSource.selectionAlias.includes("(All Members)") === false) {
                            if (dataSource.selectionAlias.includes("Comp")) {
                                let uniqueMembers = getUniqueMembers(members, dataSource, qpId, rtnVal)
                                let selectionValue = getCompDropDownAppropriateValue(dataSource, uniqueMembers)
                                if (selectionValue.label !== "" && selectionValue.value !== "") {
                                    rtnVal[qpId][dataSource.selectionAlias] = selectionValue.value
                                }
                            }

                            // If regular quickpick datasource qpSelection value does not exist in members, use default quickPicksTag.targetSelection
                            if (dataSource.selectionAlias.includes("^") === false && dataSource.selectionAlias.includes("Comp") === false &&
                                members.find(a => a.alias.toLowerCase() === rtnVal[qpId][dataSource.selectionAlias]) === null) {
                                rtnVal[qpId][dataSource.selectionAlias] = currentQp.quickPicksTag.targetSelection
                            }
                        }
                    })
                }
            }
        })

        return rtnVal
    }
    function formatQpObjForCustomQuickPicks(qpDataSource, currentQp) {
        let rtnVal = {}

        // Go through each dimension and build up the Quick Pick Object
        qpDataSource.dimensions.forEach((dimension) => {
            if (currentQp.quickPicksTag.dimensionAlias === dimension.alias) {
                if (doesThisDimensionHaveRelevantMembers(dimension) && currentQp) {
                    let qpId = currentQp.id

                    rtnVal[qpId] = {}

                    // Next we need to fill out the comps
                    let compDataSource = findDataSourceSelectionWithTheMostMembers(currentQp)
                    compDataSource.forEach(dataSource => {
                        if (dataSource.selectionAlias.includes("(All Members)") === false) {
                            rtnVal[qpId][dataSource.selectionAlias] = dataSource.selectionValue
                        }
                    })
                }
            }
        })

        const allLinkMaps = getAllLinkMapOutputSelections(currentQp)
        allLinkMaps.forEach(mapping => {
            if (!rtnVal[currentQp.id][mapping]) {
                rtnVal[currentQp.id][mapping] = findDataSourceForAltKey(currentQp,mapping)
            }
        })
        return rtnVal
    }
    function formatQpSelectionsDimensionAliases(currentQPs) {
        let rtnVal = []

        currentQPs.forEach(currentQP => {
            let lookup = rtnVal.find(x => x === currentQP.quickPicksTag.dimensionAlias);
            if (!lookup) {
                rtnVal.push(currentQP.quickPicksTag.dimensionAlias);
            }
        })

        return rtnVal
    }
    function formatGlobalPicksSourceObject(globalsSource) {
        let rtnVal = []

        if (globalsSource["globalSetDimensions"]) {
            for (let globalDimensionIndex = 0; globalDimensionIndex < globalsSource["globalSetDimensions"].length; globalDimensionIndex++) {
                let currentObject = {
                    "dimension": "",
                    "members": [],
                    "segments": []
                }
                let currentGlobal = globalsSource["globalSetDimensions"][globalDimensionIndex]
                currentObject["dimension"] = currentGlobal["alias"]
                currentObject["members"] = currentGlobal["members"]
                currentObject["segments"] = currentGlobal["segments"]
                rtnVal.push(currentObject)
            }
        }

        return rtnVal
    }
    function formatGlobalPicksSelections(presentationViewGlobals, globalsSource) {
        let rtnVal = []

        if (presentationViewGlobals && globalsSource) {
            for (let presentationGlobalIndex = 0; presentationGlobalIndex < presentationViewGlobals.length; presentationGlobalIndex++) {
                let currentGlobalSet = presentationViewGlobals[presentationGlobalIndex]
                let currentGlobalSetParameters = currentGlobalSet["globalSet"]["parameters"]
                for (let globalParamIndex = 0; globalParamIndex < currentGlobalSetParameters.length; globalParamIndex++) {
                    let currentParam = currentGlobalSetParameters[globalParamIndex]
                    let currentParamSelections = currentParam["selections"]
                    for (let selectionIndex = 0; selectionIndex < currentParamSelections.length; selectionIndex++) {
                        let selection = currentParamSelections[selectionIndex]
                        let alias = ""
                        let segmentAlias = ""
                        let segmentSystemName = ""
                        let parentName = ""
                        let parentType = -1
                        let valueAlias = null
                        let valueSystemName = null
                        let segmentCombination = null
                        let segmentSelections = null

                        if (selection["segmentAlias"] && selection["segmentSystemName"]) {
                            segmentAlias = selection["segmentAlias"]
                            segmentSystemName = selection["segmentSystemName"]
                            alias = selection["caption"]
                        } else if (selection["parentName"] && selection["parentType"]) {
                            parentName = selection["parentName"]
                            parentType = selection["parentType"]
                            alias = selection["caption"]
                        } else if (selection["segmentCombination"] && selection["segmentSelections"]) {
                            segmentCombination = selection["segmentCombination"]
                            segmentSelections = formatSegmentSelectionItemsForMultiSegments(selection["segmentSelections"], currentGlobalSet["globalSet"]["setName"], currentParam["parameterName"])
                            alias = selection["caption"]
                        } else if (selection["valueAlias"]) {
                            alias = selection["valueAlias"]
                        }

                        if (selection["valueAlias"]) {
                            valueAlias = selection["valueAlias"]
                        }
                        if (selection["valueSystemName"]) {
                            valueSystemName = selection["valueSystemName"]
                        }
                        
                        if (selection["isSelected"] && currentGlobalSet["globalSet"]["active"]) {
                            rtnVal.push({
                                "alias": alias,
                                "dimension": currentParam["dimensionAlias"],
                                "setName": currentGlobalSet["globalSet"]["setName"],
                                "parameterName": currentParam["parameterName"],
                                "segmentAlias": segmentAlias,
                                "segmentSystemName": segmentSystemName,
                                "parentName": parentName,
                                "parentType": parentType,
                                "valueAlias": valueAlias,
                                "valueSystemName": valueSystemName,
                                "segmentCombination": segmentCombination,
                                "segmentSelections": segmentSelections
                            })
                        }
                    }
                }
            }
        }
console.log(rtnVal)
        return rtnVal
    }
    function formatAllUniqueGlobalSets(presentationViewGlobals) {
        let rtnVal = ['']

        for (let globalItr = 0; globalItr < presentationViewGlobals.length; globalItr++) {
            let currentGlobal = presentationViewGlobals[globalItr]
            let currentGlobalSetName = currentGlobal["globalSet"]["setName"]

            if (!rtnVal.includes(currentGlobalSetName) && currentGlobal["globalSet"]["active"]) {
                rtnVal.push(currentGlobalSetName)
            }
        }

        rtnVal.sort((a, b) => {
            if (a === "") return -1
            if (b === "") return 1
            return a.localeCompare(b)
        })

        return rtnVal
    }
    function formatSegmentSelectionItemsForMultiSegments(segmentSelections, setName, paramName) {
        let rtnVal = []

        for (let x = 0; x < segmentSelections.length; x++) {
            let currentSegmentSelection = segmentSelections[x]
            let valueAlias = null
            let valueSystemName = null

            if (currentSegmentSelection["valueAlias"]) {
                valueAlias = currentSegmentSelection["valueAlias"]
            }
            if (currentSegmentSelection["valueSystemName"]) {
                valueSystemName = currentSegmentSelection["valueSystemName"]
            }

            rtnVal.push({
                "alias": currentSegmentSelection["caption"],
                "dimension": "",
                "setName": setName,
                "parameterName": paramName,
                "segmentAlias": currentSegmentSelection["segmentAlias"],
                "segmentSystemName": currentSegmentSelection["segmentSystemName"],
                "parentName": "",
                "parentType": -1,
                "valueAlias": valueAlias,
                "valueSystemName": valueSystemName,
                "segmentCombination": null,
                "segmentSelections": null
            })
        }

        return rtnVal
    }
    function getMembersFromDimensionForGlobalSelection(globalMembers, currentGlobalSet, currentGlobalSetParameter) {
        let rtnVal = []
        
        for (let globalMemberIndex = 0; globalMemberIndex < globalMembers.length; globalMemberIndex++) {
            let currentGlobalMember = globalMembers[globalMemberIndex]
            if (currentGlobalSetParameter["dimensionAlias"] === currentGlobalMember["dimension"]) {
                // Members
                for (let memberIndex = 0; memberIndex < currentGlobalMember["members"].length; memberIndex++) {
                    let currentMember = currentGlobalMember["members"][memberIndex]
                    if (currentMember["attributes"][currentGlobalSet["setName"]]) {
                        rtnVal.push({
                            "alias": currentMember["alias"],
                            "dimension": currentGlobalMember["dimension"],
                            "setName": currentGlobalSet["setName"],
                            "parameterName": currentGlobalSetParameter["parameterName"],
                            "segmentAlias": null,
                            "segmentSystemName": null,
                            "parentName": currentGlobalMember["dimension"],
                            "parentType": 0,
                            "valueAlias": null,
                            "valueSystemName": null,
                            "segmentCombination": null,
                            "segmentSelections": null
                        })
                    }
                }

                // Segments
                for (let segmentIndex = 0; segmentIndex < currentGlobalMember["segments"].length; segmentIndex++) {
                    let currentSegment = currentGlobalMember["segments"][segmentIndex]
                    if (currentSegment["attributes"][currentGlobalSet["setName"]]) {
                        rtnVal.push({
                            "alias": `Segment ${currentSegment["alias"]} Members`,
                            "dimension": currentGlobalMember["dimension"],
                            "setName": currentGlobalSet["setName"],
                            "parameterName": currentGlobalSetParameter["parameterName"],
                            "segmentAlias": currentSegment["alias"],
                            "segmentSystemName": currentSegment["systemName"],
                            "parentName": "",
                            "parentType": -1,
                            "valueAlias": "All",
                            "valueSystemName": "",
                            "segmentCombination": null,
                            "segmentSelections": null
                        })
                        rtnVal.push({
                            "alias": `Segment ${currentSegment["alias"]}  Rollup`,
                            "dimension": currentGlobalMember["dimension"],
                            "setName": currentGlobalSet["setName"],
                            "parameterName": currentGlobalSetParameter["parameterName"],
                            "segmentAlias": currentSegment["alias"],
                            "segmentSystemName": currentSegment["systemName"],
                            "parentName": "",
                            "parentType": -1,
                            "valueAlias": null,
                            "valueSystemName": null,
                            "segmentCombination": null,
                            "segmentSelections": null
                        })

                        // Members within segment
                        for (let segmentMemberIndex = 0; segmentMemberIndex < currentSegment["memberModels"].length; segmentMemberIndex++) {
                            let currentSegmentMember = currentSegment["memberModels"][segmentMemberIndex]
                            rtnVal.push({
                                "alias": `Segment ${currentSegment["alias"]} Value ${currentSegmentMember["alias"]}  Rollup`,
                                "dimension": currentGlobalMember["dimension"],
                                "setName": currentGlobalSet["setName"],
                                "parameterName": currentGlobalSetParameter["parameterName"],
                                "segmentAlias": currentSegment["alias"],
                                "segmentSystemName": currentSegment["systemName"],
                                "parentName": null,
                                "parentType": -1,
                                "valueAlias": currentSegmentMember["alias"],
                                "valueSystemName": currentSegmentMember["systemName"],
                                "segmentCombination": null,
                                "segmentSelections": null
                            })
                            rtnVal.push({
                                "alias": `Segment ${currentSegment["alias"]} Value ${currentSegmentMember["alias"]} Members`,
                                "dimension": currentGlobalMember["dimension"],
                                "setName": currentGlobalSet["setName"],
                                "parameterName": currentGlobalSetParameter["parameterName"],
                                "segmentAlias": null,
                                "segmentSystemName": null,
                                "parentName": `[${currentSegment["alias"]}] = [${currentSegmentMember["alias"]}]`,
                                "parentType": 1,
                                "valueAlias": currentSegmentMember["alias"],
                                "valueSystemName": currentSegmentMember["systemName"],
                                "segmentCombination": null,
                                "segmentSelections": null
                            })
                        }
                    }
                }
            }
        }

        return rtnVal
    }
    function filterMembersBasedOnSetAndParameter(allMembers, currentGlobalSet, currentGlobalSetParameter) {
        return allMembers.filter(m => m["setName"] === currentGlobalSet["setName"] && m["parameterName"] === currentGlobalSetParameter["parameterName"])
    }
    /**
     * resetNewSelectionsWithGlobalSetAndParameterMatch
     * * Resets the state object with the new values
     * @param {string} dimensionAlias - dimension alias
     * @param {string} parameterName - parameter name
     * @param {string} setName - set name
     * @param {Array} allSelections - All Global Selections
     * @param {Array} neValueFromAutoComplete - New values sent from the autocomplete
     */
    function resetNewSelectionsWithGlobalSetAndParameterMatch(dimensionAlias, parameterName, setName, allSelections, neValueFromAutoComplete) {
        let rtnVal = []

        for (let x = 0; x < allSelections.length; x++) {
            let currentSelection = allSelections[x]
            if (currentSelection["dimension"] !== dimensionAlias || currentSelection["parameterName"] !== parameterName || currentSelection["setName"] !== setName) {
                rtnVal.push(currentSelection)
            }
        }

        for (let x = 0; x < neValueFromAutoComplete.length; x++) {
            let currentSelection = neValueFromAutoComplete[x]
            rtnVal.push(currentSelection)
        }

        return rtnVal
    }
    //#endregion

    //#region Private Data Handling
    function doTheseQuickPicksHaveCustomQuickPicks(currentQPs) {
        let rtnVal = false

        currentQPs.forEach(currentQP => {
            if (currentQP.quickPicksTag.linkMaps) {
                rtnVal = true
            }
        })

        return rtnVal
    }
    function formatDimensionStateObject(qpDataSource, currentQPs, hasCustomQuickPicks) {
        let rtnVal = []

        // Go through the current quick picks and build the base level of the UI state
        currentQPs.forEach(currentQP => {
            let dimension = qpDataSource.dimensions.find(d => d.alias === currentQP.quickPicksTag.dimensionAlias)
            let compDataSource = findDataSourceSelectionWithTheMostMembers(currentQP)
            let isCustomQuickPickDropDown = hasCustomQuickPicks && currentQP.quickPicksTag.linkMaps !== null
            if (dimension && doesThisDimensionHaveRelevantMembers(dimension)) {
                if (isCustomQuickPickDropDown) {
                    let doesThisCustomQuickPickAlsoHaveStandardDropdown = currentQP.quickPicksTag.targetAlias !== "" && currentQP.quickPicksTag.targetSelection !== ""

                    currentQP.quickPicksTag.linkMaps.forEach(linkMap => {
                        rtnVal.push({
                            "id": currentQP.id,
                            "dimensionName": dimension.alias,
                            "dataSourceWitMostMembers": currentQP.quickPicksTag.dataSourceWitMostMembers,
                            "targetAlias": linkMap.mapName,
                            "members": dimension.members,
                            "segments": dimension.segments,
                            "compDataSource": compDataSource,
                            "linkMap": linkMap,
                            "linkMaps": currentQP.quickPicksTag.linkMaps
                        })
                    })

                    if (doesThisCustomQuickPickAlsoHaveStandardDropdown) {
                        rtnVal.push({
                            "id": currentQP.id,
                            "dimensionName": dimension.alias,
                            "dataSourceWitMostMembers": currentQP.quickPicksTag.dataSourceWitMostMembers,
                            "targetAlias": currentQP.quickPicksTag.targetAlias,
                            "members": dimension.members,
                            "segments": dimension.segments,
                            "compDataSource": compDataSource,
                            "linkMap": {},
                            "linkMaps": []
                        })
                    }
                } else {
                    rtnVal.push({
                        "id": currentQP.id,
                        "dimensionName": dimension.alias,
                        "dataSourceWitMostMembers": currentQP.quickPicksTag.dataSourceWitMostMembers,
                        "dominantDataSources": dimension.dominantDataSources,
                        "targetAlias": currentQP.quickPicksTag.targetAlias,
                        "members": dimension.members,
                        "segments": dimension.segments,
                        "compDataSource": compDataSource,
                        "linkMap": {},
                        "linkMaps": []
                    })
                }
            }
        })
        
        return rtnVal
    }
    function doesThisDimensionHaveRelevantMembers(dimension) {
        if (dimension.members.length > 0) {
            let rtnVal = true
            // If we see Dummy Data in the member, we can assume this is also not a legit dimension to use with Quick Picks
            dimension.members.forEach((member) => {
                if (member.alias === "Dummy Data") {
                    rtnVal = false;
                }
            })

            return rtnVal
        }

        return false
    }
    function findDataSourceSelectionWithTheMostMembers(currentQp) {
        // We need to look at a [currentQp] array of [dataSourceSelections] and find the value that contains the most members
        let dataSourceSelections = currentQp.quickPicksTag.dataSourceSelections
        let rtnVal = []

        if (dataSourceSelections) {
            let keys = Object.keys(dataSourceSelections)
            
            keys.forEach(key => {
                let current = dataSourceSelections[key]
                if (doesThisKeyNeedToBeProcessed(key)) {
                    if (rtnVal === null || current.length > rtnVal.length) {
                        rtnVal = current
                    }
                }
            })
        }
        
        return rtnVal
    }
    function findDataSourceForAltKey(currentQp,mapping) {
        // We need to look at a [currentQp] array of [dataSourceSelections] and find the value that contains the most members
        let dataSourceSelections = currentQp.quickPicksTag.dataSourceSelections
        let rtnVal = ""

        if (dataSourceSelections) {
            let keys = Object.keys(dataSourceSelections)
            
            keys.forEach(key => {
                if (doesThisKeyNeedToBeProcessed(key)) {
                    dataSourceSelections[key].forEach(dataSourceSelection => {
                        if (dataSourceSelection["selectionAlias"] && dataSourceSelection["selectionAlias"] === mapping) {
                            rtnVal = dataSourceSelection["selectionValue"]
                        }
                    })
                }
            })
        }
        
        return rtnVal
    }
    function getAllLinkMapOutputSelections(currentQp) {
        const linkMaps = currentQp.quickPicksTag.linkMaps
        let rtnVal = []

        linkMaps.forEach(mapping => {
            rtnVal.push(`^${mapping["mapOutputSelection"]}`)
        })

        return rtnVal
    }
    function doesThisKeyNeedToBeProcessed(key) {
        switch (key) {
            case 'Unknown':
            case 'Logo':
                return false
            default:
                return true
        }
    }
    function getUniqueMembers(members, dataSourceSelection, qpId, qpSelections) {
        const seen = new Set()

        // filter out duplicates
        let uniqueFilter = members.filter(el => {
            let duplicate = seen.has(el.attributes[dataSourceSelection.selectionName])
            seen.add(el.attributes[dataSourceSelection.selectionName])

            return !duplicate
        })

        // deep copy filter array, changes coming to elements
        let uniqueMembers = uniqueFilter.map(a => ({ ...a }))

        // add selected comp target alias to comp dropdown list, if mising
        if (Object.keys(qpSelections).length > 0) {
            let found = uniqueMembers.find(m => m.alias === qpSelections[qpId][dataSourceSelection.selectionAlias])
            if (typeof found == 'undefined') {
                let mem = members.find(f => f.alias === qpSelections[qpId][dataSourceSelection.selectionAlias])
                if (typeof mem !== 'undefined') {
                    let attr = mem.attributes[dataSourceSelection.selectionName]
                    let idx = uniqueMembers.findIndex(i => i.attributes[dataSourceSelection.selectionName] === attr)
                    uniqueMembers[idx].alias = qpSelections[qpId][dataSourceSelection.selectionAlias]
                }
            }
        }

        return uniqueMembers
    }
    function getCompDropDownAppropriateValue(dataSourceSelection, uniqueMembers) {
        let selectionName = dataSourceSelection.selectionName
        let selectionValue = dataSourceSelection.selectionValue
        let rtnVal = {
            "label": "",
            "value": "",
            "alias": dataSourceSelection.selectionAlias
        }

        // Get the appropriate object for this comp selection
        uniqueMembers.forEach(m => {
            if (m.attributes[selectionName] === selectionValue) {
                rtnVal.label = selectionValue
                rtnVal.value = m.alias
            }
        });

        return rtnVal
    }
    function doesThisQuickPickHaveComps(qpKeys, targetAlias) {
        let rtnVal = []

        qpKeys.forEach(key => {
            if (key !== targetAlias) {
                rtnVal.push(key)
            }
        })

        return rtnVal
    };
    function getCurrentSelection(anchorSelectionObject, anchor, qpSelections, id) {
        let rtnVal = null

        // Get the anchor's selection based on the qpSelections object
        if (typeof (anchorSelectionObject) !== "undefined") {
            // If the anchor dropdown's value was changed, use the updated value instead.
            if (typeof (qpSelections[id]) !== "undefined" && typeof (qpSelections[id][anchorSelectionObject.selectionAlias]) !== "undefined") {
                rtnVal = qpSelections[id][anchorSelectionObject.selectionAlias]
            } else if ((typeof (anchorSelectionObject)) !== "undefined") {
                //Use value from 
                rtnVal = anchorSelectionObject.selectionValue
            }
        }

        // Get anchor's selection from the state if it's set there from the user changing the dropdown
        if (typeof (qpSelections[id]) !== "undefined" && typeof (qpSelections[id][anchor.mapOutputSelection]) !== "undefined") {
            rtnVal = qpSelections[id][anchor.mapOutputSelection]
        }

        return rtnVal
    }
    function getNonAnchorCurrentSelection(dataSourceSelection, qpSelections, id, linkMap, members) {
        let rtnVal = null

        // Get anchor's selection from the state if it's set there from the user changing the dropdown
        if (dataSourceSelection !== null) {
            rtnVal = Object.keys(qpSelections).length > 0 && qpSelections[id][dataSourceSelection.selectionAlias]
        }
        if (typeof (qpSelections[id]) !== "undefined" && typeof (qpSelections[id][linkMap.mapOutputSelection]) !== "undefined") {
            rtnVal = qpSelections[id][linkMap.mapOutputSelection]
        }
        if (rtnVal !== null && rtnVal !== false) {
            let selectedMember = members.find(x => x.alias.toLowerCase().includes(rtnVal.toLowerCase()))
            //If the current selection isn't in the members, then that means the anchor dropdown as just changed, so reset this dropdown to having no selection
            if (typeof (selectedMember) === "undefined") {
                rtnVal = null
                delete (qpSelections[id][linkMap.mapOutputSelection])
            }
        }

        return rtnVal
    }
    function getAnchorChangeSelectionObject(anchorName, linkMaps, segments) {
        let rtnVal = {}

        linkMaps.forEach(linkMap => {
            if (linkMap.mapName !== anchorName && linkMap.mapAnchor === anchorName) {
                // Getting the members for each non anchor dropdowns
                let sourceSegment = segments.find(s => s.alias.toLowerCase() === linkMap.mapSource.toLowerCase());
                rtnVal[linkMap.mapOutputSelection] = {
                    "source": linkMap.mapSource,
                    "members": (sourceSegment) ? sourceSegment.memberModels : []
                };
            }
        })

        return rtnVal
    }
    //#endregion

    //#region Other Render Methods
    function renderPrimaryDropDown(hasCustomQuickPicks, members, segments, id, targetAlias, qpSelections, valueAlias, linkMap, linkMaps, compDataSource, dataSourceWitMostMembers) {
        let isCustomQuickPick = hasCustomQuickPicks && linkMap !== undefined && linkMap.mapName !== undefined
        if (isCustomQuickPick) {
            return renderQuickPickLinkMapDropDown(linkMap, linkMaps, id, compDataSource, segments, qpSelections)
        } else {
            return renderStandardQuickPickDropdown(members, id, targetAlias, qpSelections, valueAlias, dataSourceWitMostMembers)
        }
    }
    function renderStandardQuickPickDropdown(members, id, targetAlias, qpSelections, valueAlias, dataSourceWitMostMembers) {
        let quickPickValueAliasMatches = members.find(val => val.alias === valueAlias)
        let targetAttributesMatchAlias = members.find(val => val.attributes[dataSourceWitMostMembers] === qpSelections[id][targetAlias])
        // Long time issue with Pepsi, older presentations get loaded with Quick Picks set to an older style or data from quick picks ends up being altered
        // but older presentations will still have an older label. I was told there is a common work around, but in this scenario, forcing BI Cloud to a state change will 
        // cause Quick Picks to "snap" into place
        if (quickPickValueAliasMatches === undefined && targetAttributesMatchAlias !== undefined) {
            handleChange(targetAttributesMatchAlias["alias"], id, targetAlias)
        }
        return (
            <Autocomplete
                className="combo-box-demo"
                options={members}
                getOptionLabel={(option) => option.alias || ''}
                style={{ width: 375 }}
                onChange={(e, newValue) => {
                    newValue && handleChange(newValue.alias, id, targetAlias)
                }}
                value={
                    Object.keys(qpSelections).length > 0 &&
                    (
                        members.find(val => val.alias === valueAlias) ||
                        members.find(val => val.attributes[dataSourceWitMostMembers] === qpSelections[id][targetAlias])
                    )
                }
                renderInput={(params) => <TextField className="myInput" {...params} />}
            />
        )
    }
    function renderQuickPickLinkMapDropDown(linkMap, linkMaps, id, compDataSource, segments, qpSelections) {
        let isThisAnAnchor = linkMap.mapAnchor.length === 0
        let dataSourceSelection = compDataSource.find(x => x.selectionAlias.substring(1).toLowerCase() === linkMap.mapOutputSelection.toLowerCase())
        let sourceSegment = segments.find(a => a.alias.toLowerCase() === linkMap.mapSource.toLowerCase())
        let members = (sourceSegment && sourceSegment.memberModels) ? sourceSegment.memberModels.sort(dynamicSort("alias")) : []
        let currentSelection = null
        let altLookup = false

        if (typeof (dataSourceSelection) === "undefined") {
            dataSourceSelection = null
        }

        if (typeof (qpSelections[id]) !== "undefined" && typeof (qpSelections[id][linkMap.mapOutputSelection]) !== "undefined") {
            currentSelection = qpSelections[id][linkMap.mapOutputSelection]
        } else {
            currentSelection = dataSourceSelection
        }

        // Different data needs to be passed from anchors and non anchors
        if (isThisAnAnchor) {
            // In order to satisfy the requirement of having the first members selected when an anchor is changed, we need to collect the non anchor members
            let nonAnchorMembers = getAnchorChangeSelectionObject(linkMap.mapName, linkMaps, segments)
            let altSelection = ""

            if (currentSelection === null) {
                altSelection = qpSelections[id][`^${linkMap.mapOutputSelection}`]
            }

            return renderAnchorLinkMapDropdown(currentSelection, members, id, linkMap, qpSelections, nonAnchorMembers, altSelection)
        } else {
            // First we need to find the anchor for this non-anchor
            let anchor = linkMaps.find(m => m.mapName.toLowerCase() === linkMap.mapAnchor.toLowerCase())
            let anchorSelectionObject = compDataSource.find(o => o.selectionAlias.toLowerCase().substring(1) === anchor.mapOutputSelection.toLowerCase())
            let currentAnchorSelection = getCurrentSelection(anchorSelectionObject, anchor, qpSelections, id)

            // Alternative lookup due to multiple data source problems we have encountered
            if (anchorSelectionObject === undefined && currentAnchorSelection === null && qpSelections[id][`^${anchor.mapOutputSelection}`]) {
                currentAnchorSelection = qpSelections[id][`^${anchor.mapOutputSelection}`]
                altLookup = true
            }

            if (currentAnchorSelection !== null && currentAnchorSelection !== "") {
                let sourceMember = sourceSegment.memberModels.find(m => m.alias === currentAnchorSelection)
                if (linkMap.mapSourceType === 1 && sourceMember) {
                    let members = sourceMember.children.sort(dynamicSort("alias"))
                    let currentSelection = getNonAnchorCurrentSelection(dataSourceSelection, qpSelections, id, linkMap, members)
                    
                    if (currentSelection === null && altLookup) {
                        currentSelection = qpSelections[id][`^${linkMap.mapOutputSelection}`]
                    }

                    if (currentSelection !== null) {
                        return (<Autocomplete
                            className="combo-box-demo"
                            options={members}
                            getOptionLabel={(option) => option.alias || ''}
                            style={{ width: 375 }}
                            onChange={(e, newValue) => newValue && handleChange(newValue.alias, id, "^" + linkMap.mapOutputSelection)}
                            value={members.find(val => val.alias === currentSelection)}
                            renderInput={(params) => <TextField className="myInput" {...params} />}
                        />)
                    } else {
                        return (<Autocomplete
                            className="combo-box-demo"
                            options={members}
                            getOptionLabel={(option) => option.alias || ''}
                            style={{ width: 375 }}
                            onChange={(e, newValue) => newValue && handleChange(newValue.alias, id, "^" + linkMap.mapOutputSelection)}
                            value={members.find(val => val.alias === "") || ''}
                            renderInput={(params) => <TextField className="myInput" {...params} />}
                        />)
                    }
                }
            } else {
                return (<Autocomplete
                    className="combo-box-demo"
                    options={[""]}
                    getOptionLabel={(option) => option || ''}
                    style={{ width: 375 }}
                    onChange={(e, newValue) => newValue && handleChange(newValue, id, linkMap.mapOutputSelection)}
                    value={[""].find(val => val === "")}
                    renderInput={(params) => <TextField className="myInput" {...params} />}
                />)
            }
        }

        return null
    }
    function renderAnchorLinkMapDropdown(currentSelection, members, id, linkMap, qpSelections, nonAnchorMembers, alternativeSelection) {
        if (currentSelection !== null) {
            return (<Autocomplete
                className="combo-box-demo"
                options={members}
                getOptionLabel={(option) => option.alias || ''}
                style={{ width: 375 }}
                onChange={(e, newValue) => newValue && handleChangeForAnchor(newValue.alias, id, "^" + linkMap.mapOutputSelection, nonAnchorMembers)}
                value={Object.keys(qpSelections).length > 0 && members.find(val => val.alias === qpSelections[id][currentSelection.selectionAlias])}
                renderInput={(params) => <TextField className="myInput" {...params} />}
            />)
        } else if (alternativeSelection !== "") {
            return (<Autocomplete
                className="combo-box-demo"
                options={members}
                getOptionLabel={(option) => option.alias || ''}
                style={{ width: 375 }}
                onChange={(e, newValue) => newValue && handleChangeForAnchor(newValue.alias, id, "^" + linkMap.mapOutputSelection, nonAnchorMembers)}
                value={Object.keys(qpSelections).length > 0 && members.find(val => val.alias === alternativeSelection)}
                renderInput={(params) => <TextField className="myInput" {...params} />}
            />)
        } else {
            return (<Autocomplete
                className="combo-box-demo"
                options={members}
                getOptionLabel={(option) => option.alias || ''}
                style={{ width: 375 }}
                onChange={(e, newValue) => newValue && handleChangeForAnchor(newValue.alias, id, "^" + linkMap.mapOutputSelection, nonAnchorMembers)}
                value={members.find(val => val.alias === "")}
                renderInput={(params) => <TextField className="myInput" {...params} />}
            />)
        }
    }
    function renderAccordianSubDropDowns(qpKeys, targetAlias, dimensionAlias, members, compDataSource, qpId, qpSelections, hasCustomQuickPicks, linkMap, dominantDataSources) {
        let isCustomQuickPick = hasCustomQuickPicks && linkMap !== undefined && linkMap.mapName !== undefined
        if (isCustomQuickPick) {
            return null
        } else {
            return renderCompDropdowns(qpKeys, targetAlias, dimensionAlias, members, compDataSource, qpId, qpSelections, dominantDataSources)
        }
    }
    function renderCompDropdowns(qpKeys, targetAlias, dimensionAlias, members, compDataSource, qpId, qpSelections, dominantDataSources) {
        let keys = doesThisQuickPickHaveComps(qpKeys, targetAlias)
        
        if (keys.length > 0) {
            return (<Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                    <Typography style={{ fontSize: 15, fontWeight: 500 }}>Show {dimensionAlias} Comp(s)</Typography>
                </AccordionSummary>
                {compDataSource.map((dataSourceSelection, dataSourceSelectionIndex) => {
                    let key = dataSourceSelection.selectionAlias
                    let match = keys.find(k => k === key)
                    let uniqueMembers = getUniqueMembers(members, dataSourceSelection, qpId, qpSelections)

                    // We only have to check ^ if this dimension has both standard quick picks and quick picks at the same time
                    // otherwise checking for the carrot isn't necessary
                    if (match && !key.startsWith('^')) {
                        return (<AccordionDetails key={`comp-dropdown-${dimensionAlias}-${dataSourceSelectionIndex}`}>
                            <div>
                                <div>
                                    <p style={{ display: "block" }}>{dimensionAlias}: {key}</p>
                                    <div className="myInputOut" identifier="b">
                                        <Autocomplete
                                            className="combo-box-demo"
                                            options={uniqueMembers}
                                            getOptionLabel={(option) => option.attributes[dataSourceSelection.selectionName] || getAltValueFromDataSource(dataSourceSelection.selectionName, dominantDataSources, option)}
                                            style={{ width: 375 }}
                                            onChange={(e, newValue) =>  newValue && handleChange(newValue.alias, qpId, dataSourceSelection.selectionAlias) }
                                            value={(Object.keys(qpSelections).length > 0
                                                && uniqueMembers.find(y => y.alias === qpSelections[qpId][key])) || uniqueMembers.find(y => y.attributes[dataSourceSelection.selectionName] === dataSourceSelection.selectionValue)}
                                            renderInput={(params) => <TextField className="myInput" {...params} />}
                                        />
                                    </div>
                                </div>
                            </div>
                        </AccordionDetails>)
                    } else {
                        return null // Appeasings the node warnings
                    }
                })}
            </Accordion>)
        }

        return null
    }
    function getAltValueFromDataSource(selectionName, dominantDataSources, option) {
        let regexCompTest = new RegExp(' - Comp[1-9]+')
        let compStr = ''
        let rtnVal = ''

        if (regexCompTest.test(selectionName)) {
            compStr = selectionName.match(regexCompTest)[0]
            dominantDataSources.forEach(dataSource => {
                if (option.attributes[dataSource + compStr]) {
                    rtnVal = option.attributes[dataSource + compStr]
                }
            })
        }

        return rtnVal
    }
    function renderBasicGlobalsArea() {
        return null
    }
    function renderGlobalSetsDropdown() {
        if (uniqueGlobalSets && uniqueGlobalSets.length > 1) {
            return <div className="wideCenterBox" style={{ height: "auto", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} id="global-sets-dropdown">
                <h4>Global Sets</h4>
                <div className="passwordResetbox">
                    <div className="myInputOut" identifier="h">
                        <Autocomplete
                            className="combo-box-demo"
                            options={uniqueGlobalSets}
                            getOptionLabel={(option) => (typeof option === 'string') ? option : '' }
                            style={{ width: 375 }}
                            isOptionEqualToValue={(option, value) => (typeof option === 'string' && typeof value === 'string') ? option === value : false }
                            onChange={(e, newValue) => setUserSelectedGlobalSet(newValue) }
                            value={userSelectedGlobalSet}
                            renderInput={(params) => <TextField className="myInput" {...params} />}
                        />
                    </div>
                </div>
            </div>
        }
        return null
    }
    function renderEditGlobalSetsArea() {
        if (props.presentationView.globals && props.presentationView.globals.length > 0 && doesThisUserHaveThisAuthorization(props.currentUser, 'AdvancedGlobalEdit')) {
            return <div className="wideCenterBox" style={{ height: "auto", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} id="global-sets-dropdown">
                <h4>Edit Global Sets</h4>
                {props.presentationView.globals.map((global, gIndex) => {
                    let currentGlobalSet = global["globalSet"]
                    let currentGlobalSetParameters = currentGlobalSet["parameters"]
                    if (currentGlobalSet["active"]) {
                        return (<div key={`global-set-${gIndex}`}>
                            {currentGlobalSetParameters.map((param, pIndex) => {
                                return (<div className="passwordResetbox" key={`global-param-${gIndex}-${pIndex}`}>
                                    <h5>{currentGlobalSet["setName"]}.{param["parameterName"]} ({param["dimensionAlias"]})</h5>
                                    <div className="myInputOut" identifier="h">
                                        <Autocomplete
                                            className="combo-box-demo"
                                            multiple
                                            options={getMembersFromDimensionForGlobalSelection(globalSetMembers, currentGlobalSet, param)}
                                            getOptionLabel={(option) => option.alias || ''}
                                            style={{ width: 375 }}
                                            isOptionEqualToValue={(option, value) => option.alias === value.alias}
                                            onChange={(e, newValue) => {
                                                let processedNewValue = resetNewSelectionsWithGlobalSetAndParameterMatch(param["dimensionAlias"], param["parameterName"], currentGlobalSet["setName"], globalSelections, newValue)
                                                setGlobalSelections(processedNewValue)
                                            }}
                                            value={filterMembersBasedOnSetAndParameter(globalSelections, currentGlobalSet, param)}
                                            renderInput={(params) => <TextField className="myInput" {...params} />}
                                        />
                                    </div>
                                </div>)
                            })}
                        </div>)
                    }
                })}
            </div>
        }
        return null
    }
    //#endregion
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        qpDataSource: state.databases.qpDataSource,
        currentQPs: state.queries.present.currentQPs,
        currentDatabase: state.databases.currentDatabase,
        modifiedGlobals: state.queries.present.modifiedGlobals,
        presentationView: state.presentations.present.presentationView,
        currentUser: state.users.currentUser,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({
            closePopup,
            changeQPs,
            refreshPresentation
        }, dispatch)
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditQuickPickPopupFunctional))